
/*
Exemple:

<select data-component="dropdown" data-dropdown-search="true" multiple>
    <option value="">Veuillez sélectionner</option>
    <option value="1">One</option>
    <option value="2">Two</option>
    <option value="3">Three</option>
</select>
*/

import componentManager from "app/module46/component-manager.js";

/**
 * Dropdown (semantic-ui - https://semantic-ui.com)
 *
 * data-dropdown-search:
 *     Specifying to "true" will use a fuzzy full text search, setting to "exact" will force the exact search to be matched somewhere in the string, setting to "false" will only match start of string.
 *
 * data-dropdown-sort-select:
 *     Whether to sort values when creating a dropdown automatically from a select element.
 *
 * data-dropdown-clearable:
 *     Whether the dropdown value can be cleared by the user after being selected.
 * 
 * data-filter-grouped-dropdown-id:
 *     Filter the options of a dropdown specified by the id entered.
 *     The options of that dropdown must have a data-group attribute matching the value of the dropdown filtering it.
 */

function isTrue(val)
{
	return ['', '1', 'true', 'TRUE'].includes(val)
}

componentManager.register('dropdown', (component, elements, attributes) => {

	const $component = $(component);
	const fullTextSearch = isTrue(attributes['dropdownSearch']);
	const sortSelect = isTrue(attributes['dropdownSortSelect']);
	const clearable = isTrue(attributes['dropdownClearable']);
	const filterGroupedDropdownId = attributes['filterGroupedDropdownId'] ?? false;

	const $groupedSelect = $('#' + filterGroupedDropdownId);

	$component.addClass('ui ' + (fullTextSearch ? 'search' : 'fluids') + ' dropdown');

	if(filterGroupedDropdownId) {

		const $groups = $groupedSelect.find('[data-group]');
		
		function update(value) {
			if(value) {
				$groups.hide();
				$groupedSelect.find('[data-group=' + value + ']').show();
			} else {
				$groups.show();	
			}
		}

		$component.dropdown({
			fullTextSearch,
			sortSelect,
			clearable, 
			onChange: (value, text, selected) => {
				update(value);
				$groupedSelect.dropdown('clear');
			}
		});

		update($component.find('input[type=hidden]').val());

	} else {

		$component.dropdown({
			fullTextSearch,
			sortSelect,
			clearable, 
		});
	}
});
